import styled from 'styled-components'
import { black, textMuted } from '@/theme/colors'
import { fontSizes, leading } from '@/theme/typography'
import { Button } from '@components/Button'

export const ConfirmationContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	gap: 20px;
	padding: 8px 0;
`

export const ConfirmationMessage = styled.div`
	margin: 0;
	font-size: ${fontSizes.body};
	color: ${black};
	line-height: ${leading.body};
	max-width: 400px;
	text-align: center;
`

export const DeletionTarget = styled.span`
	font-weight: bold;
	color: ${black};
`

export const Disclaimer = styled.div`
	font-size: ${fontSizes.small};
	color: ${textMuted};
	font-style: italic;
	margin-top: 8px;
`

export const ConfirmationActions = styled.div`
	display: flex;
	gap: 12px;
	justify-content: center;
	width: 100%;
	margin-top: 8px;
`

/** The confirming action: danger for deletes, the primary otherwise (see ConfirmationModal). */
export const ConfirmButton = styled(Button)`
	min-width: 100px;
`

export const CancelButton = styled(Button).attrs({ variant: 'secondary' as const })`
	min-width: 100px;
`

